import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { Checkout } from './Checkout';

const WrapAuth = withAuth(Checkout);
const WrappedCheckout = withLayout(LayoutType.WithOldNavOnly, WrapAuth);

export { WrappedCheckout as Checkout };
